import * as React from "react";
import classnames from "classnames";
/* empty css            */
const Toggle = ({
  id,
  className,
  checked: isChecked,
  disabled = false,
  onChange,
  ...rest
}) => {
  const [checked, setChecked] = React.useState(isChecked);
  const handleOnChange = React.useCallback(
    (e) => {
      onChange(e.currentTarget.checked);
      setChecked(e.currentTarget.checked);
    },
    [onChange]
  );
  const handleKeyPress = React.useCallback(
    (e) => {
      if ((e.key === "Enter" || e.key === "Space") && !disabled) {
        onChange(!checked);
        setChecked(!checked);
      }
    },
    [checked, disabled, onChange]
  );
  return /* @__PURE__ */ React.createElement("label", { ...rest, className: classnames("toggle", className) }, /* @__PURE__ */ React.createElement(
    "input",
    {
      id,
      className: "toggle__input",
      type: "checkbox",
      checked,
      disabled,
      "aria-checked": checked,
      "aria-label": rest["aria-label"],
      onChange: handleOnChange,
      onKeyUp: handleKeyPress
    }
  ), /* @__PURE__ */ React.createElement("span", { className: "toggle__slider" }));
};
export {
  Toggle as default
};
//# sourceMappingURL=Toggle.js.map
